import React, { Component, useState, useEffect, useRef } from 'react'
import useStateRef from 'react-usestateref';
import Helper from '../Helper';
import { APPLICATION_JSON, ZIP_CODE_API_KEY } from '../../middleware/types';
import Loader from '../Loader';
import { Link, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import OrderSummary from './OrderSummary';

function AddAddress({ containerObject, templateName, contentId, dataZone }) {
    const [pwd, setPwd] = useState('');
    const [isRevealPwd, setIsRevealPwd] = useState(false);
    const [isChecked, setIsChecked] = useState(true);
    const [hasError, setHasError, hasErrorRef] = useStateRef(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage, setErrorMessageRef] = useStateRef();
    const [registerFormError, setRegisterForm, registerFormErrorRef] = useStateRef(false);
    const [shippingGroupDetail, setShippingGroupDetail, shippingGroupDetailRef] = useStateRef(false);
    const [checkRegisterForm, setCheckRegisterForm, checkRegisterFormRef] = useStateRef(false);
    const profileDetails = useSelector(state => state.getProfileDetails.profileDetails)
    const [city, setCity, cityRef] = useStateRef('');
    const [state, setState, stateRef] = useStateRef('');
    const [zipCode, setZipCode, zipCodeRef] = useStateRef('')
    const cache = useRef({});
    const [responseCode, setResponseCode, responseCodeRef] = useStateRef(0);
    const [orderSummaryDetails, setOrderSummaryDetails, orderSummaryDetailsRef] = useStateRef(null);
    const [isOrderSummaryLoading, setOrderSummaryLoading] = useState(false);
    const [disabled, setDisabled, disabledRef] = useStateRef(false);
    let history = useHistory();
    useEffect(() => {
        handleGetProfile()
        getOrderSummaryDetails();
    }, [])

    useEffect(() => {
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/shipping-group-details/false`, {
            method: 'GET',
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    //setIsLoading(false)
                     setShippingGroupDetail(JSON.parse(res.response).response)
                    if (shippingGroupDetailRef.current && shippingGroupDetailRef.current.displayState) {
                        document.getElementById(shippingGroupDetailRef.current.displayState).setAttribute("selected", "selected")
                    }
                } else {
                    // setIsLoading(false)
                    const error = res._ERROR_MESSAGE_;
                    // setErrorMessage(error);
                    //document.getElementById("login-message-error-div").classList.remove("d-none");

                }
            })
    }, [])
    async function handleGetProfile() {
        if (profileDetails) {
            if (profileDetails && profileDetails.transient || profileDetails.userType == '1') {
                document.getElementById("international-link").classList.remove("d-none");
                document.getElementById("international-link").classList.add("d-block");
            }
            if (profileDetails && profileDetails.userType && profileDetails.userType == '2') {
                document.getElementById("b2c-shipping").classList.remove("d-block")
                document.getElementById("b2c-shipping").classList.add("d-none")
                document.getElementById("b2i-shipping").classList.remove("d-none")
                document.getElementById("b2i-shipping").classList.add("d-block")
            }

        }
       
    }
    const getOrderSummaryDetails = async () => {
        const body = {
            "isReviewPage": false,
            "isShippingPage": true,
            "requiredReprice": true
        }
        var orderSummary = await Helper.getOrderSummary(body);
        setOrderSummaryDetails(orderSummary);
    }

    async function handleAddAddress(event) {
        event.preventDefault()
        //clearErrorMsg(event)
        setHasError(false)
        handleRemoveErrorMessage(setErrorMessageRef && setErrorMessageRef.current)
        var actionUrl = event.target.getAttribute('action');
        var data = new FormData(event.target)

        const value = Object.fromEntries(data.entries());

        // Object.entries(value).map(([key, value], keyIndex) => {
        //     validateAddresss(key, value)
        // })
        if (!hasErrorRef.current) {
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/${actionUrl}`, {
                method: 'POST',
                headers: new Headers({
                    "content-Type": "application/json",
                }),
                body: JSON.stringify(value)
            }).then(res => res.json())
                .then(res => {
                    const response = JSON.parse(res.response);
                    if (res.result == "success" && response.status == "success") {              
                        setIsLoading(false)
                        history.push("/checkout/shipping");
                    } else {
                        setIsLoading(false)
                        const errorMessageList = (response.errorMessage);
                        handleErrorMessage(errorMessageList);
                        setErrorMessage(errorMessageList);
                    }
                })
        }

    }

    function handleErrorMessage(errorMessageList){
        document.getElementById("message-error-div")?.classList.remove("d-none")
        document.getElementById("message-error-div")?.classList.add("d-block")
        errorMessageList && errorMessageList.map((item, index) => {
            document.getElementById("add_".concat(item.key))?.classList.add("form-error");
            if(document.getElementById(item.key.concat("_error"))){
                document.getElementById(item.key.concat("_error"))?.classList.remove("d-none");
                document.getElementById(item.key.concat("_error"))?.classList.add("d-block");
                document.getElementById(item.key.concat("_error")).innerHTML = item.message;
            }    
            
            document.getElementById("message-error-div")?.scrollIntoView({ behavior : 'smooth'})
        });
    }

    const handleRemoveErrorMessage = (errorMessageList) => {
        document.getElementById("message-error-div")?.classList.remove("d-block")
        document.getElementById("message-error-div")?.classList.add("d-none")
        errorMessageList && errorMessageList.map((item, index) => {
            document.getElementById("add_".concat(item.key))?.classList.remove("form-error");
            if(document.getElementById(item.key.concat("_error"))){
            document.getElementById(item.key.concat("_error"))?.classList.remove("d-block");
            document.getElementById(item.key.concat("_error"))?.classList.add("d-none");
            document.getElementById(item.key.concat("_error")).innerHTML = "";
            }
        });
    }
    function handleCallBackOrderSummary() {
        getOrderSummaryDetails();
    }
    async function handleEstimateShipping(zipCode){
        var actionUrl = "api/rest/cb/checkout/estimate-shipping";
        var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({ zipCode: zipCode }))
        if (res.result == "success") {
            getOrderSummaryDetails();
        }
    }

    async function handleZipCodeValidation(data) {
        const zipCode = data && data.zip_code? data.zip_code:'';
        if (zipCode && zipCode.length >= 5) {
            var actionUrl = "api/rest/cb/checkout/validate-zip-code";
            var Url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
            var res = await Helper.fetchCallFunction(Url, "POST", false, APPLICATION_JSON, JSON.stringify({ zipCode: zipCode }))
            if (res.result == "success") {
                handleEstimateShipping(zipCode)
            }
        } 
    }
    
    const handleZipCodeApiResponse = (data) => {
      

        if (data.error_msg) {
            // We are not showing any error to the user, simply letting the user to enter the data
           
            setResponseCode(data.error_code);
        } else if ("city" in data) {
            
            if (document.getElementById('zipcodeApiResponseCode')) {
                setResponseCode(0);
            }
           
            setCity(data.city);
            setState(data.state);
            
            handleZipCodeValidation(data);
        }
    }


    // get call to find out city and state
    function getCityAndStateByZipCode(event) {
        setZipCode(event.target.value);
        setDisabled(true);
        setCity('');
        setState('');
        setTimeout(() => {
         if(zipCodeRef.current == ''){
            setCity('');
            setState('');
         }
       
        if (Helper.isValidZipcodeUS(zipCodeRef.current.trim())) {
            if (cache.current[zipCodeRef.current]) {
                handleZipCodeApiResponse(cache.current[zipCodeRef.current]);
                setDisabled(false);
                // getOrderSummaryDetails()
            } else {
               
                const url = `https://www.zipcodeapi.com/rest/${ZIP_CODE_API_KEY}/info.json/${zipCodeRef.current.trim()}/radians`;
                fetch(url, {
                    method: 'GET',
                    headers: {
                        'Accept': APPLICATION_JSON,
                    }
                })
                    .then(response => {
                        var responseJson = response.json();
                        return responseJson;
                    })
                    .then(data => {
                        handleZipCodeApiResponse(data);
                        // getOrderSummaryDetails()
                        // Store in cache
                        cache.current[zipCodeRef.current] = data;
                        setDisabled(false);
                    })
                    .catch(err => {
                        if (document.getElementById('zipcodeApiResponseCode')) {
                            setResponseCode(err.status);
                        }
                        setDisabled(false);
                    })
            }
        }else{
            setCity('');
            setState('');
            setDisabled(false);
        }

    },500)
    }

    const [showTooltip, setShowTooltip] = useState(false);
    const [showTooltip1, setShowTooltip1] = useState(false);

    const handleMouseEnter = () => {
        setShowTooltip(true);
    };

    const handleMouseLeave = () => {
        setShowTooltip(false);
    };
    const handleMouseEnter1 = () => {
        setShowTooltip1(true);
    };

    const handleMouseLeave1 = () => {
        setShowTooltip1(false);
    };
    const clearErrorMsg = (e) => {
        document.getElementById("message-error").innerHTML = "";
        document.getElementById("message-error-div").classList.add("d-none");
        var elems = document.querySelectorAll(".form-control");
        [].forEach.call(elems, function (el) {
            el.classList.remove("form-error");
        });
    }
    const validateAddresss = (key, value) => {
        switch (key) {
            case "companyName":
                var result = Helper.isEmpty(value)
                var validation = /^[a-zA-Z0-9@ \-]+$/
                var regex = RegExp(validation);
                if (result) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    var emptyFirstName = document.getElementById("companyName_error")
                    emptyFirstName.innerHTML = "Company Name is a required field";
                    document.getElementById("add_companyName").classList.add("form-error")
                } else if (!regex.test(value)) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    document.getElementById("companyName_error").innerHTML = "Institution cannot contain special characters (such as asterisks, ampersands, etc.).";
                    document.getElementById("add_companyName").classList.add("form-error")
                } else {
                    //document.getElementById("message-error-div").classList.remove("d-none") '<p className="error mb-1 ' + "" + '">' + message + '</p>'
                    var emptyFirstName = document.getElementById("companyName_error")
                    emptyFirstName.innerHTML = "";
                    document.getElementById("add_companyName").classList.remove("form-error")
                }
                break;

            case "address1":
                var result = Helper.isEmpty(value);
                if (result) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    var emptyErrorMessage = document.getElementById("address1_error")
                    emptyErrorMessage.innerHTML = "Street Address is a required field.";
                    document.getElementById("add_address1").classList.add("form-error")
                }
                else {
                    // document.getElementById("message-error-div").classList.remove("d-none")
                    var emptyFirstName = document.getElementById("address1_error")
                    emptyFirstName.innerHTML = "";
                    document.getElementById("add_address1").classList.remove("form-error")
                }
                break;
            case "state":
                var result = Helper.isEmpty(value);
                if (result) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    var emptyErrorMessage = document.getElementById("state_error")
                    emptyErrorMessage.innerHTML = "state is a required field";
                    document.getElementById("add_state").classList.add("form-error")
                }
                else {
                    // document.getElementById("message-error-div").classList.remove("d-none")
                    var emptyFirstName = document.getElementById("state_error")
                    emptyFirstName.innerHTML = "";
                    document.getElementById("add_state").classList.remove("form-error")
                }
                break;
            case "city":
                var result = Helper.isEmpty(value);
                if (result) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    var emptyErrorMessage = document.getElementById("city_error")
                    emptyErrorMessage.innerHTML = "city is required field";
                    document.getElementById("add_city").classList.add("form-error")
                }
                else {
                    var emptyFirstName = document.getElementById("city_error")
                    emptyFirstName.innerHTML = "";
                    document.getElementById("add_city").classList.remove("form-error")
                }
                break;

            case "postalCode":
                var result = Helper.isEmpty(value)
                var validation = /^(\d{5}|\d{5}-\d{4})$/
                var regex = RegExp(validation);
                if (result) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    var emptyFirstName = document.getElementById("postalCode_error")
                    emptyFirstName.innerHTML = "Zip Code is a required field.";
                    document.getElementById("add_postalCode").classList.add("form-error")

                } else if (!regex.test(value)) {
                    setHasError(true)
                    document.getElementById("message-error-div").classList.remove("d-none")
                    document.getElementById("message-error-div").classList.add("d-block")
                    document.getElementById("postalCode_error").innerHTML = "Zip Code must contain at least 5 numbers.";
                    document.getElementById("add_postalCode").classList.add("form-error")
                } else {
                    // document.getElementById("message-error-div").classList.remove("d-none")
                    var emptyFirstName = document.getElementById("postalCode_error")
                    emptyFirstName.innerHTML = "";
                    document.getElementById("add_postalCode").classList.remove("form-error")
                }
                break;
            default:
        }
    }

    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail c-container`}>
            <div className="row justify-content-center c-account-page c-school-page c-shipping-page add-address-page">
                <div className="col-12 col-md-11 my-5 add-shipping-address">
                    {isLoading && <Loader message={"CheckoutForm"} />}
                    <div className="row">

                        <div id="visibleElement" class="col-12 col-md-8">
                            <div id="message-error-div" className="d-none alert alert-danger">
                                <div className="col-12">
                                    {/* <div id='resultExisitingError' style={{ color: "black" }} dangerouslySetInnerHTML={{ __html: setErrorMessageRef.current }}></div> */}
                                    <div id='companyName_error' style={{ color: "black" }}></div>
                                    <div id="address1_error" style={{ color: "black" }}></div>
                                    <div id='postalCode_error' style={{ color: "black" }}></div>
                                    <div id='city_error' style={{ color: "black" }}></div>
                                    <div id='state_error' style={{ color: "black" }}></div>
                                    <div id="message-error" className="col-12 err-message-text"></div>
                                </div>
                            </div>
                            <div id="shipping-formError" class="alert alert-danger ml-5 mb-3">
                            </div>
                            <form method="post" action="addb2iAddress" id="addB2IAddressForm" onSubmit={handleAddAddress} class="c-account-page">

                                <div class="row">
                                    <div class="col-md-6 text-left mb-3">
                                        <Link to="/checkout/addressBook" class="c-back-link">
                                            � cancel
                                        </Link>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6 col-md-6 text-left mb-3">
                                        <h1 class="c-account-heading">Add New Shipping Address</h1>
                                    </div>
                                    <div class="col-6 col-md-6 text-end mb-3">
                                        <Link to="/checkout/addressBook" class="c-international-link">
                                            <i class="bi bi-book-fill"></i>
                                            view address book
                                        </Link>
                                    </div>
                                </div>

                                <div class="row g-3 mb-3">
                                    <div class="col-md-12">
                                        <label class="form-label" for="company">School or Company</label>
                                        <input maxlength="40" name="companyName" id="add_companyName" type="text" class="form-control" />
                                    </div>
                                </div>

                                <div class="row g-3 mb-3">
                                    <div class="col-md-12">
                                        <label class="form-label" for="address">Street Address</label>
                                        <input maxlength="40" name="address1" id="add_address1" type="text" class="form-control" />
                                    </div>
                                </div>

                                <div class="row g-3 mb-3">
                                    <div class="col-md-6">
                                        <label class="form-label" for="zip">Zip</label>
                                        <input maxlength="10" name="postalCode" id="add_postalCode" type="text" value={zipCodeRef.current && zipCodeRef.current ?
                                                    zipCodeRef.current : ""} onChange={(e)=>getCityAndStateByZipCode(e)} class="form-control" />
                                    </div>

                                </div>

                                <div class="row g-3 mb-3">
                                    <div class="col-12 col-md-6">
                                        <label class="form-label" for="city">City</label>
                                        <input maxlength="30" name="city" id="add_city" onChange={(e)=>{setCity(e.currentTarget.value);}} value={cityRef.current?cityRef.current:''} type="text" class="form-control" />

                                    </div>
                                    <div class="col-12 col-md-6">
                                        <label class="form-label" for="state">State</label>

                                        <select name="state" id="add_state" class="form-control">
                                                    <option id="default-select" selected={stateRef.current === '' ? true : false}></option>
                                                    <option id="AL" selected={stateRef.current === 'AL' ? true : false} value="AL">AL - Alabama</option>
                                                    <option id="AK" selected={stateRef.current === 'AK' ? true : false} value="AK">AK - Alaska</option>
                                                    <option id="AZ" selected={stateRef.current === 'AZ' ? true : false} value="AZ">AZ - Arizona</option>
                                                    <option id="AR" selected={stateRef.current === 'AR' ? true : false} value="AR">AR - Arkansas</option>
                                                    <option id="CA" selected={stateRef.current === 'CA' ? true : false} value="CA">CA - California</option>
                                                    <option id="CO" selected={stateRef.current === 'CO' ? true : false} value="CO">CO - Colorado</option>
                                                    <option id="CT" selected={stateRef.current === 'CT' ? true : false} value="CT">CT - Connecticut</option>
                                                    <option id="DE" selected={stateRef.current === 'DE' ? true : false} value="DE">DE - Delaware</option>
                                                    <option id="DC" selected={stateRef.current === 'DC' ? true : false} value="DC">DC - District of Columbia</option>
                                                    <option id="FL" selected={stateRef.current === 'FL' ? true : false} value="FL">FL - Florida</option>
                                                    <option id="GA" selected={stateRef.current === 'GA' ? true : false} value="GA">GA - Georgia</option>
                                                    <option id="HI" selected={stateRef.current === 'HI' ? true : false} value="HI">HI - Hawaii</option>
                                                    <option id="ID" selected={stateRef.current === 'ID' ? true : false} value="ID">ID - Idaho</option>
                                                    <option id="IL" selected={stateRef.current === 'IL' ? true : false} value="IL">IL - Illinois</option>
                                                    <option id="IN" selected={stateRef.current === 'IN' ? true : false} value="IN">IN - Indiana</option>
                                                    <option id="IA" selected={stateRef.current === 'IA' ? true : false} value="IA">IA - Iowa</option>
                                                    <option id="KS" selected={stateRef.current === 'KS' ? true : false} value="KS">KS - Kansas</option>
                                                    <option id="KY" selected={stateRef.current === 'KY' ? true : false} value="KY">KY - Kentucky</option>
                                                    <option id="LA" selected={stateRef.current === 'LA' ? true : false} value="LA">LA - Louisiana</option>
                                                    <option id="ME" selected={stateRef.current === 'ME' ? true : false} value="ME">ME - Maine</option>
                                                    <option id="MD" selected={stateRef.current === 'MD' ? true : false} value="MD">MD - Maryland</option>
                                                    <option id="MA" selected={stateRef.current === 'MA' ? true : false} value="MA">MA - Massachusetts</option>
                                                    <option id="MI" selected={stateRef.current === 'MI' ? true : false} value="MI">MI - Michigan</option>
                                                    <option id="MN" selected={stateRef.current === 'MN' ? true : false} value="MN">MN - Minnesota</option>
                                                    <option id="MS" selected={stateRef.current === 'MS' ? true : false} value="MS">MS - Mississippi</option>
                                                    <option id="MO" selected={stateRef.current === 'MO' ? true : false} value="MO">MO - Missouri</option>
                                                    <option id="MT" selected={stateRef.current === 'MT' ? true : false} value="MT">MT - Montana</option>
                                                    <option id="NE" selected={stateRef.current === 'NE' ? true : false} value="NE">NE - Nebraska</option>
                                                    <option id="NV" selected={stateRef.current === 'NV' ? true : false} value="NV">NV - Nevada </option>
                                                    <option id="NH" selected={stateRef.current === 'NH' ? true : false} value="NH">NH - New Hampshire</option>
                                                    <option id="NJ" selected={stateRef.current === 'NJ' ? true : false} value="NJ">NJ - New Jersey</option>
                                                    <option id="NM" selected={stateRef.current === 'NM' ? true : false} value="NM">NM - New Mexico</option>
                                                    <option id="NY" selected={stateRef.current === 'NY' ? true : false} value="NY">NY - New York</option>
                                                    <option id="NC" selected={stateRef.current === 'NC' ? true : false} value="NC">NC - North Carolina</option>
                                                    <option id="ND" selected={stateRef.current === 'ND' ? true : false} value="ND">ND - North Dakota</option>
                                                    <option id="OH" selected={stateRef.current === 'OH' ? true : false} value="OH">OH - Ohio</option>
                                                    <option id="OK" selected={stateRef.current === 'OK' ? true : false} value="OK">OK - Oklahoma</option>
                                                    <option id="OR" selected={stateRef.current === 'OR' ? true : false} value="OR">OR - Oregon</option>
                                                    <option id="PA" selected={stateRef.current === 'PA' ? true : false} value="PA">PA - Pennsylvania</option>
                                                    <option id="RI" selected={stateRef.current === 'RI' ? true : false} value="RI">RI - Rhode Island</option>
                                                    <option id="SC" selected={stateRef.current === 'SC' ? true : false} value="SC">SC - South Carolina</option>
                                                    <option id="SD" selected={stateRef.current === 'SD' ? true : false} value="SD">SD - South Dakota</option>
                                                    <option id="TN" selected={stateRef.current === 'TN' ? true : false} value="TN">TN - Tennessee</option>
                                                    <option id="TX" selected={stateRef.current === 'TX' ? true : false} value="TX">TX - Texas</option>
                                                    <option id="UT" selected={stateRef.current === 'UT' ? true : false} value="UT">UT - Utah</option>
                                                    <option id="VT" selected={stateRef.current === 'VT' ? true : false} value="VT">VT - Vermont</option>
                                                    <option id="VA" selected={stateRef.current === 'VA' ? true : false} value="VA">VA - Virginia</option>
                                                    <option id="WA" selected={stateRef.current === 'WA' ? true : false} value="WA">WA - Washington</option>
                                                    <option id="WV" selected={stateRef.current === 'WV' ? true : false} value="WV">WV - West Virginia</option>
                                                    <option id="WI" selected={stateRef.current === 'WI' ? true : false} value="WI">WI - Wisconsin</option>
                                                    <option id="WY" selected={stateRef.current === 'WY' ? true : false} value="WY">WY - Wyoming</option>
                                        </select>
                                    </div>
                                </div>
                                <input id="zipcodeApiResponseCode" name='zipcodeApiResponseCode' type="hidden" value={responseCodeRef.current} />
                                <div class="row g-3 mb-3 mt-3">
                                    <div class="col-md-6 d-grid">
                                        <input type="submit" class="btn btn-primary block" disabled={disabledRef.current == true ? true:""} value="Add Address &amp; Continue" />
                                    </div>
                                </div>
                            </form>
                        </div>

                    <OrderSummary orderSummaryDetails={orderSummaryDetailsRef.current} isOrderSummaryLoading={isOrderSummaryLoading} handleCallBackOrderSummary={handleCallBackOrderSummary} />  
                    </div>

                    <div id="checkoutSpacer"></div>


                </div>
                <div className="modal fade c-modal" id="default-modal" tabindex="-1" aria-labelledby="defaultModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a">
                        <div className="modal-content">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            </button>
                            <div className="modal-body">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default AddAddress
